import Item from './item'

export default function ItemList({
  groupKey,
  items,
  selectedIds,
  onChange
}) {
  const getGroupKey = (item) => (groupKey || item.group.key)
  const isItemSelected = (item) => (
    selectedIds[getGroupKey(item)]
    && (
      selectedIds[getGroupKey(item)].includes(item.id)
      || selectedIds[getGroupKey(item)].includes(item.uuid)
    )
  )

  return items.map((item) => (
    <Item
      key={[getGroupKey(item), item.id]}
      item={item}
      value={isItemSelected(item)}
      onChange={(checked) => onChange(item, checked)}
    />
  ))
}
